
































import { ORDER_CLARIFICATIONS } from '@/helpers/helpers';
import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator';

@Component
export default class TextFieldWithTooltip extends Vue {
  @Prop() label!: string;
  @Prop() textfieldKey!: string;
  @Prop() model!: string;
  @Prop() rules: [];
  
  // left in case client wants clickable tooltip
  // showTooltip = false;

  // toggleTooltip() {
  //   this.showTooltip = !this.showTooltip;
  // }

  @Watch('model')
  callEmit() {
    this.setModel(this.model);
  }

  getClarificationText(key: string): string {
    return ORDER_CLARIFICATIONS[key];
  }

  @Emit('update-model')
  setModel(model: string): string {
    return model;
  }

}
